import type { RegisterOptions } from "react-hook-form";
import { Form } from "@circle-react-uikit/Form";

interface FormItemProps {
  children: React.ReactNode;
  className?: string;
  errorClassName?: string;
  hideLabel?: boolean;
  hidePlaceholder?: boolean;
  inlineReverse?: boolean;
  isDisabled?: boolean;
  label?: string;
  labelClassName?: string;
  name: string;
  placeholder?: string;
  rules?: RegisterOptions;
  tooltipText?: string;
  tooltipTextClassName?: string;
  translationRoot?: string;
  variant?: string;
}

export const FormItem = ({
  children,
  name,
  rules = {},
  tooltipText,
  hidePlaceholder = false,
  placeholder,
  inlineReverse = false,
  translationRoot = "events.edit_modal",
  hideLabel = false,
  className = "",
  tooltipTextClassName = "",
  errorClassName,
  ...props
}: FormItemProps) => (
  <Form.Item
    name={name}
    hideDescription
    translationRoot={translationRoot}
    rules={rules}
    hideBorder
    fullWidth
    hidePlaceholder={hidePlaceholder}
    placeholder={placeholder}
    tooltipText={tooltipText}
    inlineReverse={inlineReverse}
    hideLabel={hideLabel}
    className={className}
    tooltipTextClassName={tooltipTextClassName}
    errorClassName={errorClassName}
    {...props}
  >
    {children}
  </Form.Item>
);
